import { LessonExercise, shows } from '../../mockLessonContent';
import ImageZoom from '../ImageZoom';
import OptionalSupport from './OptionalSupport';

// Render within each card's content area, never beside the player navigation.
export default function ExerciseSupport({ exercise }: { exercise: LessonExercise }) {
    const content = exercise.kind === 'word'
        ? { definition: exercise.definition }
        : exercise.kind === 'listenRepeat'
            ? { definition: exercise.definition, example: exercise.example }
            : exercise;
    return <>
        {exercise.kind !== 'word' && exercise.kind !== 'image' && exercise.emoji && shows(exercise, 'picture') &&
            <ImageZoom emoji={exercise.emoji} alt="Exercise illustration" height={150} fontSize={64} rounded />}
        <OptionalSupport content={content} display={{ ...exercise.display, info: shows(exercise, 'info'), pinyin: shows(exercise, 'pinyin') }} />
    </>;
}
